export function binary_objsearch_iterative(a, value) {
  var lo = 0,
    hi = a.length - 1,
    mid;
  while (lo <= hi) {
    mid = Math.floor((lo + hi) / 2);
    if (a[mid].GetObjectID() > value) hi = mid - 1;
    else if (a[mid].GetObjectID() < value) lo = mid + 1;
    else return mid;
  }
  return null;
}
